import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { useDispatch } from 'react-redux';
import { editComplaint, fetchComplaints } from '../../app/reducers/Complaints/complaintSlice';
import moment from 'moment';

const ObservationModal = ({
    openObservationModal,
    setOpenObservationModal,
    complaintData,
    page,
    status
}) => {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...complaintData,
            observationNotes: '',
            observationDate: '',
        },
        validationSchema: object({
            observationNotes: string().required(),
            observationDate: string().required(),
        }),
        onSubmit: async (values) => {
            console.log('values', values)
            await dispatch(editComplaint({
                ...values,
                status: 'observation'
            }))
            await dispatch(fetchComplaints({
                populate: true,
                page,
                status
            }))
            setOpenObservationModal(false);
            formik.resetForm();
        }
    });

    useEffect(() => {
        if (openObservationModal) {
            formik.setFieldValue('observationDate', moment().valueOf());
        }
    }, [openObservationModal]);

    return (
        <ModalBasic
            modalOpen={openObservationModal}
            setModalOpen={setOpenObservationModal}
            title={'Add Observation'}
            max_width="max-w-lg"
        >
            <div className="p-4">
                <form
                    className="flex flex-col gap-4"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="grid grid-cols-2 gap-3 pb-4 border-b border-slate-200">
                        <FormikInputGroup formik={formik} label="Complaint No." name="complaintNumber" readOnly value={`CMP-${formik.values.complaintNumber || ''}`} />
                        <FormikInputGroup formik={formik} label="Customer" name="customer.name" readOnly />
                        <FormikInputGroup formik={formik} label="Company" name="customer.companyData.name" readOnly />
                        <FormikInputGroup formik={formik} label="Machine" name="product.name" readOnly />
                        <FormikInputGroup formik={formik} label="Technician" name="assignedTo" readOnly />
                        <div className="col-span-2">
                            <FormikInputGroup formik={formik} label="Description" name="description" readOnly fullWidth />
                        </div>
                    </div>

                    <FormikInputDateGroup
                        formik={formik}
                        label="Observation Date"
                        name="observationDate"
                        required
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                    />
                    <FormikInputGroup
                        formik={formik}
                        name="observationNotes"
                        label="Observation Note"
                    />
                    <div className="">
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                </form>
            </div>
        </ModalBasic>
    );
};

export default ObservationModal;
